import React, { useContext } from 'react';
import { number, oneOfType, shape, string } from 'prop-types';
import classNames from 'classnames/bind';
import { Placeholder } from '@thd-olt-component-react/core-ui';
import { StoreMapPreview } from '@thd-olt-component-react/store-map';
import { StorePodContext } from '../../StorePod.context';
import styles from './store-pod-map.module.scss';

const cx = classNames.bind(styles);

export const StorePodMap = ({
  className,
  mapOptions
}) => {
  const { loading, store } = useContext(StorePodContext);

  if (loading) {
    return (
      <div className={cx(className, 'store-pod-map')} data-testid="store-pod-map-loader">
        <Placeholder
          type="rect"
          height={`${mapOptions?.height}px`}
          width={`${mapOptions?.width}px`}
        />
      </div>
    );
  }

  return (
    <div className={cx(className, 'store-pod-map')} data-testid="store-pod-map">
      <StoreMapPreview mapOptions={mapOptions} store={store} />
    </div>
  );
};

StorePodMap.displayName = 'StorePodName';

StorePodMap.propTypes = {
  className: string,
  mapOptions: shape({
    height: oneOfType([string, number]),
    width: oneOfType([string, number]),
    zoom: oneOfType([string, number])
  })
};

StorePodMap.defaultProps = {
  className: null,
  mapOptions: {
    height: '100',
    width: '100',
    zoom: '13'
  }
};
